import React, { ReactElement, FunctionComponent, useRef } from 'react';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import ReactMarkdown from 'react-markdown';
import './pulse-anim.css';

interface CompProps {
  className?: string;
  reason?: string | null;
}
type Props = CompProps;
export const More: FunctionComponent<Props> = (props: Props): ReactElement => {
  const { reason = null } = props;

  const contentRef = useRef<any>(null);

  return (
    <Tooltip
      placement='right'
      arrow
      title={reason && <ReactMarkdown>{reason}</ReactMarkdown>}
    >
      <Box
        tabIndex={0}
        ref={contentRef}
        sx={{
          display: 'flex',
          // alignSelf: 'stretch',
          // alignItems: 'center',
          justifyContent: 'center',
          minWidth: '4em',
          maxWidth: '6em',
          // fontSize: '10px',
          backgroundColor: 'var(--Action-Background)',
          color: 'black',
          borderRadius: '0 5px 4px 0',
          // pointerEvents: !reason ? 'none' : 'all',
          cursor: 'pointer',
        }}
      >
        <span>More</span>
      </Box>
    </Tooltip>
  );
};
